import request from "@/utils/request";
import qs from "qs";
// =================抽奖活动 start ====================================================
/**
 * 查询抽奖活动列表
 * @param params
 * @return {*}
 */
export function getRaffleActivityList(params) {
  return request({
    url: "/raffle/activity/getList",
    method: "get",
    params
  });
}

/**
 * 新增-编辑抽奖活动
 * @param params
 * @return {*}
 */
export function editRaffleActivity(params) {
  return request.post("/raffle/activity/edit", qs.stringify(params));
}

/**
 * 修改抽奖活动状态
 * @param params
 * @return {*}
 */
export function updateRaffleActivityStatus(params) {
  return request.post("/raffle/activity/updateStatus", qs.stringify(params));
}

// =================抽奖活动 end ====================================================

// =================奖品配置 start ====================================================
/**
 * 查询抽奖奖品列表
 * @param params
 * @return {*}
 */
export function getPrizesList(params) {
  return request({
    url: "/raffle/prizes/getList",
    method: "get",
    params
  });
}
/**
 * 新增-编辑抽奖奖品
 * @param params
 * @return {*}
 */
export function editRafflePrizes(params) {
  return request.post("/raffle/prizes/edit", qs.stringify(params));
}

/**
 * 删除奖品
 * @param params
 * @return {*}
 */
export function deleteRafflePrizes(params) {
  return request.post("/raffle/prizes/delete", qs.stringify(params));
}

/**
 * 查询抽奖奖品详情
 * @param params
 * @return {*}
 */
export function getRafflePrizesDetail(params) {
  return request({
    url: "/raffle/prizes/getDetail",
    method: "get",
    params
  });
}

/**
 * 查询奖项类型
 * @param params
 * @return {*}
 */
export function getTypes(params) {
  return request({
    url: "/raffle/prizes/getTypes",
    method: "get",
    params
  });
}
// =================奖品配置 end ====================================================

// =================抽奖记录 start ====================================================

/**
 * 查询抽奖记录列表
 * @param params
 * @return {*}
 */
export function getRaffleRecordList(params) {
  return request({
    url: "/raffle/record/getList",
    method: "get",
    params
  });
}

/**
 * 发货回执
 * @param params
 * @return {*}
 */
export function deliveryFeedback(params) {
  return request.post("/raffle/record/deliveryFeedback", qs.stringify(params));
}
// =================抽奖记录 end ====================================================

// 查询奖励池余额
export function getRafflePoolBalance(params) {
  return request({
    url: "/raffle/activity/getBonusPool",
    method: "get"
  });
}

export function getPrizesLogDetail(params) {
  return request({
    url: "/raffle/record/getDetail",
    method: "get",
    params
  });
}
